import { GridColDef } from "@mui/x-data-grid"
import ScrollableDataGrid from "./ScrollableDataGrid"

interface Props {
    rows: readonly any[]
    columns: GridColDef<any>[]
    onRowClick?: (params: any) => void
    getRowClassName?: (params: any) => string
    sx?: object
}

const CustomTable = ({ rows, columns, onRowClick, getRowClassName, sx }: Props) => {

    return <ScrollableDataGrid
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 15 },
                    },
                }}
                pageSizeOptions={[10, 15, 20, 25]}
                onRowClick={onRowClick}
                getRowClassName={getRowClassName}
                sx={{
                    ...(onRowClick ? { '& .MuiDataGrid-row': { cursor: 'pointer' } } : {}),
                    ...sx
                }}
            />
}

export default CustomTable